import React, { useEffect, useState } from 'react'

import Topbar from './Topbar'
import Sidebar_component from './Sidebar_component'
import { useNavigate } from 'react-router-dom';

export default function Bilable_hours() {
  const navigate = useNavigate();
  const [projectList, setProjectList] = useState([]);
  const [selectedProject, setSelectedProject] = useState('');
  const [projectData, setProjectData] = useState(null);
  const [resultData, setResultData] = useState(null);
  const [hourRate, setHourRate] = useState(0);
  const [hourRateinput, showHourrateInput] = useState(false);
  const [sendInvoicePart, showSendInvoicePart] = useState(false);
  const [clientDetails, setClientDetailst] = useState([]);
  const [showInvoicePreview, setShowInvoicePreview] = useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [showAlertBox, setShowAlertBox] = useState(false);
  const [alertMsg, setAlertMsg] = useState('');
  const [showLoader, setShowLoader] = useState(false);
  const [membretype, setMembertype] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);


  useEffect(() => {
    let memtype = localStorage.getItem('membership_type');
    if (memtype === 'free') {
      setMembertype(true);
    }
    loadProjects();
  }, []);

  async function loadProjects() {
    try {
      let com_id =
        localStorage.getItem('mem_company_id');
      const response = await fetch(
        'getProjectsForBilling.php',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            company_id: com_id
          })
        }
      );
      const data = await response.json();
      setProjectList(data);
    } catch (error) {
      console.log(error);
    }
  }

  async function calculatehours(e) {
    const projectId = e.target.value;
    setSelectedProject(projectId);
    try {
      const response = await fetch(
        'calculateBillableHours.php',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            project_id: projectId,
            hour_rate: hourRate
          })
        }
      );
      const data = await response.json();
      setResultData(data);
      showSendInvoicePart(true);
    } catch (error) {
      console.log(error);
    }
  }
  function openoptionPlate() {
    showHourrateInput(true)
  }
  function closeOptionPlate() {
    showHourrateInput(false)
  }
  function startInvoice() {
    let rateprice = document.getElementById('perhourrate').value;
    if (resultData.total_hours == 0) {
      alert('You have not done any work for this project so you cannot generate an invoice')
    } else if (rateprice == '') {
      alert('Please insert your p[er hour rate')
    } else {
      const inv = generateInvoiceNumber();
      setInvoiceNumber(inv);
      let finalreate = Number(rateprice);
      setHourRate(finalreate)
      checkClientDetails()
    }
  }
  async function checkClientDetails() {
    try {
      const response = await fetch(
        'getClientDetails.php',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            pro_id: selectedProject
          })
        }
      );
      const data = await response.json();
      if (data.status === 'success') {
        setClientDetailst(data.data);
        openInvoicePreview(data.data);
      }
      else {
        alert(
          'Insufficient client data found for this project.'
        );
      }
    } catch (error) {
      console.log(error);
    }
  }
  function openInvoicePreview(clientData) {
    setShowInvoicePreview(true);
  }
  function closeInvoicePreview() {
    setShowInvoicePreview(false);
  }
  async function generateInvoice() {
    setShowLoader(true)
    try {
      const response = await fetch(
        'generateInvoice.php',
        {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/json'
          },

          body: JSON.stringify({
            invoice_number: invoiceNumber,
            project_id: selectedProject,
            project_name: resultData.project_name,
            total_hours: resultData.total_hours,
            bill_amount: Number(resultData.total_hours) * Number(hourRate),
            start_date: resultData.start_date,
            end_date: resultData.end_date,
            billing_date: resultData.billing_date,
            client_name: clientDetails.cl_name,
            client_email: clientDetails.cl_email,
            client_token: clientDetails.access_token,
            rate_per_hour: hourRate,
            sender_name: localStorage.getItem('mem_company_name')
          })
        }
      );
      const data = await response.json();
      if (data.status === 'success') {
        sendInvoiceMail(
          data.billing_id,
          data.pdf_path
        );

        console.log(data);
      } else {
        showAlert('Failed to generate invoice');
      }
    } catch (error) {
      console.log(error);
    }

  }

  async function sendInvoiceMail(
    billingId,
    pdfPath
  ) {
    try {
      const response = await fetch(
        'sendInvoiceMail.php',
        {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/json'
          },
          body: JSON.stringify({
            billing_id: billingId,
            pdf_path: pdfPath,
            client_email: clientDetails.cl_email,
            client_name: clientDetails.cl_name,
            invoice_number: invoiceNumber,
            project_name: resultData.project_name,
            total_amount: Number(resultData.total_hours) * Number(hourRate),
            sender_name: localStorage.getItem('mem_company_name'),
            company_email: localStorage.getItem('useremail')
          })
        }
      );
      const data = await response.json();
      console.log(data.status)
      if (data.status == 'success') {
        setShowLoader(false);
        closeInvoicePreview()
        showAlert('Invoice sent successfully');
      } else {
        showAlert('Mail sending failed');
      }
    } catch (error) {
      console.log(error);
    }

  }

  function generateInvoiceNumber() {
    const today = new Date();
    const year = today.getFullYear();
    const random = Math.floor(10000 + Math.random() * 90000);
    return `INV-${year}-${random}`;
  }


  const showAlert = (msg) => {
    setAlertMsg(msg);
    setShowAlertBox(true);
  };

  const closeAlert = () => {
    setShowAlertBox(false);
    setAlertMsg('');
  };

  function invoicelist() {
    navigate('/invoicelist');
  }

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div>
      <Topbar toggleSidebar={toggleSidebar} />
      <Sidebar_component sidebarOpen={sidebarOpen} />
      <div className='vl_dsh_bodypart'>
        <div className='vl_alltab'>
          <h2 className='bigfonttabs'>
            Calculate Billable hours
          </h2>
          <button className='allinvoice' onClick={invoicelist}>View All Invoices</button>
          <p className='fullwidth pull_left pb-30'>
            Calculate billable hours for a project. Create invoice and send it to client instantly.
          </p>
        </div>
        <div className='fullwidth'>
          <p className='pt-15 pb-30 pull_left fullwidth'>This page helps you calculate billable hours for a project. The system automatically calculates hours from the last billing date up to yesterday. You can also generate invoices and send them directly to your clients with minimal effort. </p>
          <div className='pro_dropdown'>
            <select onChange={calculatehours}>
              <option value=''>
                Select Project
              </option>
              {
                projectList.map((item, index) => (
                  <option
                    key={index}
                    value={item.id}
                  >
                    {item.pr_name}
                  </option>
                ))
              }

            </select>
            {
              sendInvoicePart && (

                <div className='pull_right pos_rel'>
                  <button className='option_button' onClick={openoptionPlate}>Send Invoice</button>
                  {
                    hourRateinput && (
                      <div className='rate_input'>
                        <input type="number" min="0" max="500" placeholder='Insert your per hour rate' id="perhourrate" name="perhourrate" />
                        <button className='sendbtn' onClick={startInvoice}><i class="ri-arrow-right-up-fill"></i></button>
                        <button className='closePlate' onClick={closeOptionPlate}>+</button>
                      </div>
                    )
                  }

                </div>
              )
            }

          </div>
          {
            resultData && (

              <div className='resultarea'>
                <p>
                  <span>Project Name: </span>
                  {resultData.project_name}
                </p>
                <p>
                  <span>Total Billable Hours: </span>
                  {resultData.total_hours}h
                </p>
                <p>
                  <span>Bill Amount: </span>
                  ${resultData.bill_amount}
                </p>
                <p>
                  <span>Billing Session: </span>
                  {resultData.start_date}
                  {' '}to{' '}
                  {resultData.end_date}
                </p>

                <p>
                  <span>Billing Date: </span>
                  {resultData.billing_date}
                </p>
              </div>
            )
          }
        </div>
      </div>
      {
        showInvoicePreview && (
          <div className='invoice_preview'>
            <div className='closebtnholder'>
              <button className='closeBtn pdfclosebtn' onClick={closeInvoicePreview} >+</button>
            </div>
            <h2>Invoice Preview</h2>
            <div className='invoice_box'>
              <div className='headerpart fullwidth pull_left mb-10'>
                <div className='vl_dsh_one_half bottom_border'>
                  <p>
                    <span>Invoice Number:</span>
                    {' '}
                    {invoiceNumber}
                  </p>
                </div>
                <div className='vl_dsh_one_half bottom_border'>
                  <p>
                    <span>Invoice Date:</span>
                    {' '}
                    {resultData.billing_date}
                  </p>
                </div>

                <p className='bottom_border'><span>From:</span>
                  {' '}
                  {
                    localStorage.getItem(
                      'mem_company_name'
                    )
                  }
                </p>


                <p className='bottom_border'>
                  <span>Client Name:</span>
                  {' '}
                  {clientDetails.cl_name}
                </p>
                <p className='bottom_border'>
                  <span>Client Email:</span>
                  {' '}
                  {clientDetails.cl_email}
                </p>
                <p className='bottom_border'>
                  <span>Client ID:</span>
                  {' '}
                  {clientDetails.access_token}
                </p>

                <p className='bottom_border'>
                  <span>Project Name:</span>
                  {' '}
                  {resultData.project_name}
                </p>
                <p>
                  <span>Billing Session:</span>
                  {' '}
                  {resultData.start_date}
                  {' '}to{' '}
                  {resultData.end_date}
                </p>
              </div>
              <div className='bodyarea'>
                <div className='pdfrow mb-30'>
                  <div className='vl_dsh_one_fourth tableheadr'><p>Item</p></div>
                  <div className='vl_dsh_one_fourth tableheadr'><p>Total Hours</p></div>
                  <div className='vl_dsh_one_fourth tableheadr'><p>Rate Per Hour</p></div>
                  <div className='vl_dsh_one_fourth tableheadr norightborder'><p>Total Amount</p></div>
                </div>
                <div className='pdfrow'>
                  <div className='vl_dsh_one_fourth'> <p>1</p></div>
                  <div className='vl_dsh_one_fourth'><p>{resultData.total_hours}</p></div>
                  <div className='vl_dsh_one_fourth'><p>${hourRate}</p></div>

                  <div className='vl_dsh_one_fourth'><p>
                    $
                    {
                      Number(
                        resultData.total_hours
                      ) * Number(hourRate)
                    }
                  </p></div>
                </div>
              </div>

              <div className='invoice_buttonholder'>
                <button onClick={generateInvoice}>
                  Confirm & Generate Invoice
                </button>

              </div>

            </div>

          </div>

        )
      }

      {showAlertBox && (
        <div className='vl_dsh_popup activebillpop'>
          <div className='alertbox'>
            <div className='alertheader'>
              <h3><i className='ri-alert-line'></i>Alert</h3>
            </div>

            <div className='contentarea'>
              <p>{alertMsg}</p>
            </div>

            <div className='alert_btns'>
              <button onClick={closeAlert}>Okay</button>
            </div>
          </div>
        </div>
      )}
      {showLoader && (
        <div className='loaderpop'>
          <div className='loader_inner'>
            <p>Please wait...We are working</p>
          </div>
        </div>
      )}

      {membretype && (
        <div className='vl_dsh_popup activebillpop'>
          <div className='alertbox'>
            <div className='alertheader'>
              <h3><i className='ri-alert-line'></i>Alert</h3>
            </div>

            <div className='contentarea'>
              <p>Please upgrade your membership to access this page</p>
            </div>

            <div className='alert_btns'>
              <button onClick={() => window.history.back()}>Back</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
